/**
* Бэкэнд интерфейс для виджета реализующий прием платежей в пользу поставщика
*/
module.exports = {
  /**
   * Получение парамтеров для инизацлизации виджета
   *
   * @param {String} provider guid поставщика, размещается на сайте поставщика услуги
   * @param {Number} type  тип виджета, значение из Constants.WIDGET_TYPE_*
   * @returns {Params}
   */
  getParams(provider, type) {},

  /**
   * Поиск услуг по номеру лицевого счета
   *
   * @param {String} provider guid поставщика, размещается на сайте поставщика услуги
   * @param {String} account номер лицевого счета введенный плательщиком
   * @param {Map<String,String>} params значения дополнительных параметров
   * @param {String} captcha токен капчи
   * @returns {Services}
   */
  searchService(provider, account, params, captcha) {},

  /**
   * @deprecated
   * Расчет комиссии
   * 
   * @param {String} paySystem guid платежной систмы
   * @param {Array<String>} services список guid-ов услуг
   * @returns {Total}
   */
  calcTotal(paySystem, services) {},

  /**
   * Расчет комиссии для произвольных сумм
   *
   * @param {String} provider guid поставщика, размещается на сайте поставщика услуги
   * @param {String} paySystem guid платежной систмы
   * @param {Map<String, String>} servicesSumm список сумм по идентификаторам услуг
   * @returns {Total}
   */
  calcTotalWithSumm(provider, paySystem, servicesSumm) {},

  /**
   * @deprecated
   * Сохранение платежа
   *
   * @param {String} paySystem guid платежной систмы
   * @param {List<String>} services список guid-ов услуг
   * @param {String} phoneEmail телефон или e-mail, для получения фискального чека и регистрации
   * @param {Boolean} needRegister true-необходимо провести региcтрацию, может указываться true только в случае если
   * @returns {Payment}
   */
  savePayment(paySystem, services, phoneEmail, needRegister) {},

  /**
   * Сохранение платежа
   *
   * @param {String} provider guid поставщика, размещается на сайте поставщика услуги
   * @param {String} paySystem guid платежной систмы
   * @param {Map<String, String>} servicesSumm список guid-ов услуг
   * @param {String} phoneEmail телефон или e-mail, для получения фискального чека и регистрации
   * @param {Boolean} needRegister true-необходимо провести региcтрацию, может указываться true только в случае если
   * @returns {Payment}
   */
  savePaymentWithSumm(provider, paySystem, servicesSumm, phoneEmail, needRegister) {},

  /**
   * @notused
   * Проведение платежа через Apple Pay
   *
   * @param unp номер платежа
   * @param network
   * @param instrument
   * @param transaction
   * @param email
   * @param data данные для передачи эквайеру
   * @return {Boolean} в случае успешно проведенного платежа возвращается true, иначе false
  */
  applePay(unp, network, instrument, transaction, email, data) {},

  /**
   * @notused
   * Проведение платежа через Google Pay
   *
   * @param {String} unp номер платежа
   * @param {String} data данные для передачи эквайеру
   * @return {String} в случае успешно проведенного платежа возвращается строка 'Платеж успешно обработан'
   */
  googlePay(unp, data) {},

  /**
   * получение списка прибров учета по номеру лицевого счета
   *
   * @param {String} provider идентификатор поставщика
   * @param {String} account номер лицевого счета
   * @param {Map<String,String>} params список дополнительных параметров
   * @param {String} captcha капча (заполнется при необходомости)
   * @return {Meters} адрес помещения, список приборов учета
   */
  searchMeters(provider, account, params, captcha) {},

  /**
   * @deprecated
   * Отправка показания
   *
   * @param {List<MeterReading>} readings список показаний
   * @returns {Map<String, ServiceCharge>}
   */
  meterReading(readings) {},

  /**
   * отправка показания c расчетом начислений
   *
   * @param {String} provider guid поставщика услуги
   * @param {List<MeterReading>} readings список показаний
   * @returns {Map<String, ServiceCharge>}
   */
  sendReading(provider, readings) {},

  /**
   * Список населенных пунктов
   * 
   * @param {String} provider guid поставщика услуги
   * @returns {List<AddrObj>}
   */
  cities(provider) {},

  /**
   * Список улиц
   * 
   * @param {String} provider guid поставщика услуги
   * @param {String} cityId идентификатор населенного пункта
   * @returns {List<AddrObj>}
   */
  streets(provider, cityId) {},

  /**
   * Список домов
   * 
   * @param {String} provider guid поставщика услуги
   * @param {String} cityId идентификатор населенного пункта
   * @param {String} cityId идентификатор улицы
   * @returns {List<AddrObj>}
   */
  houses(provider, cityId, streetId) {},

  /**
   * Список квартир
   * 
   * @param {String} provider guid поставщика услуги
   * @param {String} cityId идентификатор населенного пункта
   * @param {String} cityId идентификатор улицы
   * @param {String} houseId идентификатор дома
   * @returns {List<AddrObj>}
   */
  aparts(provider, cityId, streetId, houseId) {},

  /**
   * Список лс по адресу
   * 
   * @param {String} provider guid поставщика услуги
   * @param {String} cityId идентификатор населенного пункта
   * @param {String} cityId идентификатор улицы
   * @param {String} houseId идентификатор дома
   * @param {String} apartId идентификатор квартиры
   * @returns {List<Account>}
   */
  accounts(provider, cityId, streetId, houseId, apartId) {},

  /**
   * Получить статус платежа
   * SAVED, PAID
   * 
   * @param {String} unp номер платежа
   * @returns {String} SAVED || PAID
   */
  paymentStatus(unp) {},

  /**
   * Автокомплит для адреса
   *
   * @param {String} picked строка выбранная из автокомплита
   * @param {String} entered введенная строка
   * @return {Autocomplete}
   */
  autocomplete(picked, entered) {},

  /**
   * Список абонентов по адресу
   *
   * @param {String} picked строка выбранная из автокомплита
   * @param {String} entered введенная строка
   * @return {List<Abonent>} 
   */
  abonents(picked, entered) {}
}

/**
* Номер лицевого счета
*
* @property {String} account лицевой счет
*/
class Account {
  account
}

/**
* Адерсный объект  - город улица дом квартира
*
* @property {String} id идентификатор
* @property {String} name наименование или номер дома/ квартиры
* @property {Boolean} complete true - по этому объекту один лицевой счет
*/
class AddrObj {
  id
  name
  complete
}

/**
* Структара для передачи показаний счетчика
*
* @property {String} meter идентификатор счетчика
* @property {String} reading показания
*/
class MeterReading {
  meter
  reading
}

/**
* Результат поиска
*
* @property {String} address адрес
* @property {Boolean} withoutCharge
* @property {List<Service>} services список услуг
* @property {Total} total суммы платежа и комиссии, при оплате по первой платежной системе
* @property {List<PaySystem>} paySystems список долступных платежных систем
* @property {Boolean} canRegister возможно регистрация
*/
class Services {
  address
  withoutCharge
  services
  total
  paySystems
  canRegister
}

/**
* Услуга
*
* @property {String} guid идентификатор
* @property {String} name наименование
* @property {String} debt сумма задолженности (+ задолженность, - переплата)
* @property {Boolean} hasCharge true - показывать начисление, false - показывать кнопку для перехода к подче показаний
* @property {String} charge начисление
* @property {String} amount к оплате
* @property {String} tarif тариф для подсказки
*/
class Service {
  guid
  name
  debt
  hasCharge
  charge
  amount
  tarif
}

/**
* Описание платежной системы
*
* @property {String} code идентификатор
* @property {String} guid идентификатор
* @property {String} name намиенование
* @property {String} image ссылка на изображение
* @property {Number} imageId идентификатор изображения для мобильных приложений
* @property {String} desc опсиание
* @property {Number} type тип платежной системы из Constants.AGENT_TYPE_*
* @property {String} offerUrl ссылку на оферту
*/
class PaySystem {
  code
  guid
  name
  image
  imageId
  desc
  type
  offerUrl
}

/**
* Итоговая сумма платежа (с комиссией)
*
* @property {String} total сумма платежа с комиссией
* @property {String} commission сумма комисии
*/
class Total {
  total
  commission
}

/**
* Параметры для инифиализации виджета
*
* @property {String} captchaKey ключ для инициализации виджета капчи
* @property {List<Field>} fields список полей которые дополнительно должен заполнять плательщик
* @property {String} privacyPolicyUrl
* @property {String} iconUrl
* @property {String} mainSite
*/
class Params {
  captchaKey
  fields
  privacyPolicyUrl
  iconUrl
  mainSite
}

/**
* Описание поля которое необходимо отобразить виджету
*
* @property {String} name имя поля
* @property {String} label подпись
* @property {String} type тип поля text, password или другие html типы
* @property {Boolean} value занечние поумолчанию
* @property {Boolean} optional опциональность параметра
*/
class Field {
  name
  label
  type
  value
  optional
}

/**
* Информация о платеже возвращаемая после сохранения
*
* @property {String} message сообщение (чек)
* @property {String} unp уникальный номер платежа
* @property {String} url ссылка на платежную систему
* @property {Int} type тип платежной систмы из Constants.AGENT_TYPE_*
* @property {Total} total сумма платежа, комиссия
*/
class Payment {
  message
  unp 
  url
  type
  total
}

/**
* Перечень приборов учета
*
* @property {String} address адрес помещения (например Барнаул, Ленина пр-т, 54, 23)
* @property {List<Meter} meters список приборов учета
*/
class Meters{
  address
  meters
}

/**
* Информация о приборе учета
*
* @property {String} guid идентификатор
* @property {String} service наименование услуги (например Холодное водоснабжение)
* @property {String} location размещение (например кухня)
* @property {String} check срок поверки в формате дд.мм.гггг
* @property {Boolean} checkSoon скоро поверка
* @property {String} measure единица измерения (например м3)
* @property {String} prev предыдущее показание разедлитель дробной части "." (напрмиер 1234.456)
* @property {String} prevDate дата снятия предыдущего показания в формате дд.мм.гггг
* @property {String} current предыдущее показание разедлитель дробной части "." (напрмиер 1234.456)
* @property {String} currentDate дата снятия предыдущего показания в формате дд.мм.гггг
* @property {Number} capacity разрядность, количество знаков до запятой
* @property {Number} fraction количество знаков после запятой
* @property {Number} maxConsum максимальное значение расходи
* @property {Boolean} canReading открыта ли возможность подачи показаний
* @property {String} message сообщение от поставщика
* @property {Array<String>} services список идентификаторов услуг, которые зависят от этого прибора учета
*/
class Meter {
  guid
  service
  location
  check
  checkSoon
  measure
  prev
  prevDate
  capacity
  fraction
  maxConsum
  canReading
  message
  services
}

/**
 * 
 * @property {AddrSplit} current
 * @property {Boolean} currentComplete
 * @property {AddrSplit} options
 */
class Autocomplete {
    current
    currentComplete
    options
}

/**
 * 
 * @property {String} city
 * @property {String} street
 * @property {String} building
 * @property {String} apartment
 * @property {Number} len
 * 
 */
class AddrSplit {
    city
    street
    building
    apartment
    len
}

/**
 * Абонент
 * 
 * @property {String} id
 * @property {String} account
 * @property {String} name
 * @property {String} fio
 * @property {Boolean} defaultWired
 * @property {Boolean} canWire
 * @property {String} error
 */
class Abonent {
      id
      account
      name
      fio
      defaultWired
      canWire
      error
}

/**
* Расчитанное начисление по услугам
*
* @property {String} charge сумма начисления
* @property {String} amount новая сумма к оплате
* @property {Boolean} hasCharge показывать начисление или кнопку подачи показаний
*/
class ServiceCharge {
  charge
  amount
  hasCharge
}

/**
* Тип агенты наличные
*/
const AGENT_TYPE_CASH = 0

/**
* Обычная оплата
*/
const AGENT_TYPE_REGULAR = 1

/**
* Google Pay
*/
const AGENT_TYPE_GOOGLE_PAY = 2

/**
* Apple Pay
*/
const AGENT_TYPE_APPLE_PAY = 3

/**
* Тип виджета прием платежа
*/
const WIDGET_TYPE_PAYMENT = 1

/**
* Тип виджета передача показания приборов учета
*/
const WIDGET_TYPE_INDICATION = 2

  


